module.exports = __webpack_public_path__ + "img/79371f5e5cf7336ba80818613f42379c_01-b83fab01f5b92d01e42f8295bc0e57b4-tuya.34f6e7b8.png";